import { Box, CircularProgress, styled } from '@mui/material';
import Sidebar from './Sidebar';
import SearchBar from './SearchBar';
import { PropsWithChildren } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import Column from 'components/Layout/Column';

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100vh',
  width: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  transition: 'all 0.01s ease',
  backgroundColor: theme.palette.background.default,
}));

const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  width: '100%',
  maxWidth: `calc(100% - ${theme.sidebar.width}px)`,
  boxSizing: 'border-box',

  [theme.breakpoints.down(theme.sidebar.drawerBreakpoint)]: {
    maxWidth: '100%',
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: `calc(100vh - ${theme.searchBar.height}px)`,
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: 0,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.borderColor.main}`,
  borderTopLeftRadius: 16,
  overflowX: 'hidden',
  overflowY: 'auto',

  [theme.breakpoints.down(theme.sidebar.drawerBreakpoint)]: {
    borderTopLeftRadius: 0,
  },
}));

const FullHeightLoader = styled(Column)(() => ({
  position: 'absolute',
  inset: 0,
  alignItems: 'center',
  justifyContent: 'center',
}));

const NewLayout: React.FC<PropsWithChildren> = ({ children }) => (
  <Wrapper>
    <Sidebar />
    <MainContainer>
      <SearchBar />
      <ContentContainer>
        <ErrorBoundary
          loader={
            <FullHeightLoader centered fullWidth>
              <CircularProgress size={24} />
            </FullHeightLoader>
          }
        >
          {children}
        </ErrorBoundary>
      </ContentContainer>
    </MainContainer>
  </Wrapper>
);

export default NewLayout;
